import {
  usePopulationServicedCommunity,
  usePopulationBusStop,
} from '@src/modules/performance/context/reports-api-hooks';

import { Link, Text, Wrap } from '@chakra-ui/react';
import LineChart from '@src/modules/performance/components/charts/LineChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Public Transport Community Serviced',
  content: [
    {
      title: 'Population of serviced community',
      description:
  <Text fontSize="inherit" mb={2}>
    This measure reports the population of the serviced communities.
  </Text>,
      source: null,
    },
    {
      title: '% population within 500m of a bus stop',
      description:
  <Text fontSize="inherit" mb={2}>
    This measure reports the percentage of the serviced communities that are within 500m of a bus stop.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, use - public transport</Link>
  </Text>,
    },
  ],
};

function PublicTransportCommunityServiced() {
  const { data: populationServicedCommunity, isLoading: isLoadingPopulationServicedCommunity } = usePopulationServicedCommunity();
  const { data: populationBusStop, isLoading: isLoadingPopulationBusStop } = usePopulationBusStop();
  const isLoading = isLoadingPopulationServicedCommunity || isLoadingPopulationBusStop;

  // Population Serviced Chart Data
  const populationServicedCommunityYears = [...new Set(populationServicedCommunity?.map((item) => item.Year))];
  const populationServicedCommunityChartData = [
    {
      name: 'Population',
      type: 'line',
      data: populationServicedCommunity?.map((item) => ({
        x: item.Year,
        y: item.Population,
      })),
      color: CHART_COLOURS.blue,
    },
  ];

  // Population Bus Stop Chart Data
  const populationBusStopYears = [...new Set(populationBusStop?.map((item) => item.Year))];
  const populationBusStopChartData = [
    {
      name: 'Population',
      type: 'line',
      data: populationBusStop?.map((item) => ({
        x: item.Year,
        y: item.PercWithin500m,
      })),
      color: CHART_COLOURS.blue,
    },
  ];

  return (
    <ReportSection
      title="Public Transport Community Serviced"
      isLoading={isLoading || !populationServicedCommunity || !populationBusStop}
      informationSource={informationSource}
      lockYear={populationServicedCommunity?.[0]?.LockYear || populationBusStop?.[0]?.LockYear}
    >
      <Wrap>
        <LineChart
          title={['Population of serviced', 'community']}
          categories={populationServicedCommunityYears}
          series={populationServicedCommunityChartData}
          width="220"
          height="280"
          decimalPoints={2}
          yAxisDecimalPoints={2}
        />
        <LineChart
          title={['% population within', '500m of a bus stop']}
          categories={populationBusStopYears}
          series={populationBusStopChartData}
          width="220"
          height="280"
          decimalPoints={1}
          yAxisDecimalPoints={1}
          suffix="%"
        />
      </Wrap>
    </ReportSection>
  );
}

export default PublicTransportCommunityServiced;
